/* eslint-disable */
import {
  DateSelectArg,
  DatesSetArg,
  EventApi,
  EventDropArg,
  EventInput,
  EventSegment,
  EventSourceInput
} from '@fullcalendar/core'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import dayGridPlugin from '@fullcalendar/daygrid'
import rrulePlugin from '@fullcalendar/rrule'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin, {
  DateClickArg,
  EventResizeDoneArg
} from '@fullcalendar/interaction'
import { withObservables } from '@nozbe/watermelondb/react'
/* eslint-enable */

import './styles.scss'

import * as Styled from './styled'
import ObserveService from 'services/db/Observe'
import { dayHeaderClassNames } from 'utils/calendar'
import {
  AllDayContent,
  DayCellContent,
  DayHeaderContent,
  EventContent,
  getEventInstanceTimes,
  SlotLabelContent
} from './components'
import {
  CALENDAR_VIEW,
  useCalendar
} from 'components/providers/CalendarProvider'
import { AddIcon } from 'assets/icons'
import { Model } from 'types/model'
import {
  AccountDoc,
  AccountProduct,
  DocType,
  EventDoc,
  EventStatus,
  GroupDoc,
  TaskType,
  UserSettingsDoc
} from 'types/api/changes'
import { compose } from 'recompose'
import dayjs, { Dayjs, ManipulateType } from 'dayjs'
import { StartEndEvent, generateStartEndBasedOnTimeWithShift } from 'utils/date'
import {
  addTempEventToDate,
  localEventById,
  localEventByLocalId
} from 'services/db/Queries/Event'
import {
  localGroupById,
  provideFirstGroup
} from 'services/db/Queries/GroupQueries'
import { LocalStorageKey } from 'types/services/localStorage'
import LocalStorage from 'services/LocalStorage'
import { useEffect, useState, useCallback, useMemo } from 'react'
import {
  isGroupNotAvailableForEventChanges,
  isGroupOutOfTier,
  isUserActiveInGroup,
  isUserCanOperateEvents,
  isUserHaveGroupToAddEvents
} from 'utils/api/groups'
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog'
import { getProfilesForParticipants } from 'services/api/group'
import { exhaustedProduct, highestActiveTier } from 'utils/api/accounts'
import { OutOfTierDialog } from 'components/tier/OutOfTierDialog'
import { APP_COLOR } from 'utils/colors'
import Analytics, {
  BlockedFlow,
  EventProperties,
  Events
} from 'analytics/Analytics'
import { getEventsForGroup } from 'services/api/event'
import Logger from 'services/Logger'
import { t } from 'i18next'
import i18n from 'i18n'
import { usePayment } from 'components/providers/PaymentProvider'
import {
  getArchivedGroups,
  getDeletedGroups,
  isGroupArchived,
  isGroupHidden
} from 'utils/api/userSettings'
import { CalendarRange } from 'types/components/calendar'
import Database from 'services/db/Database'
import { updateEventOnServer } from 'services/api/event'
import RecurrentActionDialog from 'components/dialogs/RecurrentActionDialog'
import {
  RECUR_SAVE_TYPE,
  parseErrorToMessage
} from 'components/popups/eventInfo/EventPopup'
import { AxiosError } from 'axios'
import { Box, Tooltip, useTheme } from '@mui/material'
import { EventsListPopupContent } from 'components/popups/EventsListPopup'
import Event from './components/Event'
import { is24meApp, isGroupcalApp } from 'utils/appType'
import {
  defaultGroupId,
  groupToProvider,
  isConvertedGroup,
  ProviderType
} from 'utils/groups'
import React from 'react'
import { useAppSettings } from 'components/providers/AppSettingsProvider'
import ListView, { calculateListViewRange } from './ListView'
import { useCalendarSync } from 'components/providers/CalendarSyncProdivder'
import { CurrentConvertedCalendars } from 'utils/google_events'
import {
  icloudPrefix,
  outlookPrefix,
  prefixGoogleEventsGroup
} from 'utils/constants'

import { ResyncCalendarDialog } from 'components/dialogs/ResyncGoogleDialog'
import { Ref } from '@fullcalendar/core/preact'
import FullCalendar from '@fullcalendar/react'
import { isCypress } from 'utils/cypress'
import { getDefaultTimezone } from 'index'
import { isTrulyEmpty, removePrefix } from 'utils/object'
import { eventIdForContainer, eventLengthInDays } from 'utils/event'
import { isGuest } from 'utils/user'
import {
  isEventInstanceWithinTimePeriod,
  isEventRecurrenceInstanceValid,
  isLateInstance,
  isSomeDayInstance
} from 'utils/api/instance_state'

import { useEventPopover } from './eventPopover/EventPopoverProvider'
import { mapEventsToCalendar } from 'utils/fc_mapping'
import { provideReferenceGroup } from 'utils/api/group_state'
import TFloatingPopover from 'components/popovers/TFloatingPopover'
import { useAuth } from 'components/providers/AuthProvider'
import { useLandlineCheck } from 'components/providers/LandlineCheckProvider'
import { isUserOutOfTierBasedOnLandline } from 'utils/tier'
import { useEventActions } from 'components/providers/EventActionsProvider'
import { useChatbase } from 'components/providers/ChatbaseProvider'
import { mapRecurrency } from 'utils/recurrence'
import EventContextMenu from 'components/contextMenu/EventContextMenu'

import { rrulestr } from 'rrule'
import { useNetworkStatus } from 'hooks/useNetworkStatus'
import adaptivePlugin from '@fullcalendar/adaptive'
import GalleryView from './GalleryView'
import { isInIframe } from 'utils/env'

export enum FIRST_DAYS {
  SUNDAY = 1,
  MONDAY = 2,
  SATURDAY = 7
}

interface CalendarViewProps {
  events: Model<EventDoc>[]
  groups: Model<GroupDoc>[]
  userSettings: Model<UserSettingsDoc>
  groupID: string
  group: Model<GroupDoc>
  readOnly?: boolean
  firstGroup: Model<GroupDoc>
  account: Model<AccountDoc>
  defaultView?: CalendarRange
  showOnlySelectedGroup?: boolean
  dayNameFormat?: string
  visibleFrom?: number
  visibleTo?: number
  groupIds?: string[]
  embedMode: boolean
}

interface DateRange {
  leftBound: number
  rightBound: number
}

interface DropEventData {
  newEvent: EventApi
  oldEvent: Model<EventDoc>
  oldAllDay: boolean
  oldStart: number
  oldEnd: number
  oldTimeZone: string
  newStart: number
  newEnd: number
}

function CalendarView(props: CalendarViewProps) {
  const calendarSync = useCalendarSync()
  const theme = useTheme()
  const [showUserRemovedDialog, setShowUserRemovedDialog] = useState(false)
  const calendar = useCalendar()
  const [userCannotAddEvents, setUserCanAddEvents] = useState(false)
  const [showOutOfTierDialog, onShowOutOfTierDialog] = useState(false)
  const [dateRange, onDateRange] = useState<DateRange>()
  const activeTier = useMemo(
    () => highestActiveTier(props.account),
    [props.account?._rev]
  )
  const isOutOfTier = useMemo(
    () => isGroupOutOfTier(activeTier, props.group, props.account),
    [activeTier, props.group, props.account?._rev]
  )
  const [showCalendarSync, onShowCalendarSync] = useState(false)

  const auth = useAuth()

  const showCanOperateEventsIfNeeded = useCallback(() => {
    if (
      props.group &&
      !isUserCanOperateEvents(
        props.group,
        LocalStorage.get(LocalStorageKey.USER_ID)!
      )
    ) {
      ;(calendar.ref as any).current?.getApi().unselect()
      showCanAddEventsDialog()
      return true
    }

    return false
  }, [props.group, calendar.ref])

  const showSyncIfNeeded = useCallback(() => {
    if (props.group?.SyncProblem === '1') {
      ;(calendar.ref as any).current?.getApi().unselect()

      onShowCalendarSync(true)
      return true
    }

    return false
  }, [props.group?.SyncProblem, calendar.ref])

  const showCanAddEventsDialog = useCallback(() => {
    setUserCanAddEvents(true)
  }, [])

  const hideCanAddEventsDialog = useCallback(() => {
    setUserCanAddEvents(false)
  }, [])

  const hideUserRemovedDialog = useCallback(() => {
    setShowUserRemovedDialog(false)
  }, [])

  const showUserRemoved = useCallback(() => {
    setShowUserRemovedDialog(true)
  }, [])

  const userRemoved =
    !isUserActiveInGroup(
      props.group,
      LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
    ) && (LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? '').length > 0

  const onDatesSet = useCallback(
    (datesSetArg: DatesSetArg) => {
      Logger.blue('DatesSet: ', datesSetArg)
      const nowDayJs = dayjs()
      let offset = new Date().getTimezoneOffset()
      if (offset > 0) {
        //
      } else if (offset < 0) {
        offset = Math.abs(offset)
      } else {
        //
      }
      const startDayJs = dayjs(datesSetArg.start.valueOf()).add(
        offset,
        'minute'
      )
      const endDayJs = dayjs(datesSetArg.end.valueOf())
        .add(offset, 'minute')
        .add(-1, 'second')

      const centerDayJs = dayjs((startDayJs.valueOf() + endDayJs.valueOf()) / 2)

      calendar.onFromISO(startDayJs.toISOString())
      calendar.onToISO(endDayJs.toISOString())
      ;(datesSetArg.view as any).dateEnv.defaultSeparator = '\n'

      let timePeriod: ManipulateType = 'day'

      if (
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) ===
          CalendarRange.MONTH ||
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) === CalendarRange.CARDS
      ) {
        timePeriod = 'month'
      } else if (
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) ===
          CalendarRange.WEEK ||
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) ===
          CalendarRange.LISTWEEK
      ) {
        timePeriod = 'week'
      }

      const shouldManipulate =
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) !==
          CalendarRange.LISTWEEK &&
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) !==
          CalendarRange.LISTDAY

      const oldFrom = LocalStorage.get(LocalStorageKey.VISIBLE_FROM)
      const oldTo = LocalStorage.get(LocalStorageKey.VISIBLE_TO)

      LocalStorage.set(
        LocalStorageKey.VISIBLE_FROM,
        startDayJs.subtract(shouldManipulate ? 1 : 0, timePeriod).toISOString()
      )
      LocalStorage.set(
        LocalStorageKey.VISIBLE_TO,
        endDayJs.add(shouldManipulate ? 1 : 0, timePeriod).toISOString()
      )

      Logger.debug('old from/to', oldFrom, oldTo)
      Logger.debug(
        'set visible from/to',
        LocalStorage.get(LocalStorageKey.VISIBLE_FROM),
        LocalStorage.get(LocalStorageKey.VISIBLE_TO)
      )
      Logger.debug(
        'First get changes',
        auth.firstGetChangesFinished,
        LocalStorage.get(LocalStorageKey.USER_ID)
      )

      if (
        (oldFrom !== LocalStorage.get(LocalStorageKey.VISIBLE_FROM) ||
          oldTo !== LocalStorage.get(LocalStorageKey.VISIBLE_TO)) &&
        auth.firstGetChangesFinished &&
        LocalStorage.get(LocalStorageKey.USER_ID)
      ) {
        calendarSync.sync()
      }

      onDateRange({
        leftBound: startDayJs.unix(),
        rightBound: endDayJs.unix()
      })

      if (
        datesSetArg.view.type === 'dayGridMonth' ||
        datesSetArg.view.type === 'galleryMonth'
      ) {
        if (nowDayJs.isAfter(startDayJs) && nowDayJs.isBefore(endDayJs)) {
          LocalStorage.set(LocalStorageKey.VISIBLE_DATE, nowDayJs.valueOf())
        } else if (centerDayJs.month() != nowDayJs.month()) {
          LocalStorage.set(
            LocalStorageKey.VISIBLE_DATE,
            startDayJs
              .add(centerDayJs.month() != startDayJs.month() ? 1 : 0, 'week')
              .valueOf()
          )
        } else {
          if (startDayJs.month() === nowDayJs.month()) {
            LocalStorage.set(LocalStorageKey.VISIBLE_DATE, startDayJs.valueOf())
          } else {
            LocalStorage.set(
              LocalStorageKey.VISIBLE_DATE,
              startDayJs.add(1, 'week').valueOf()
            )
          }
        }
      } else {
        if (nowDayJs.isAfter(startDayJs) && nowDayJs.isBefore(endDayJs)) {
          LocalStorage.set(LocalStorageKey.VISIBLE_DATE, nowDayJs.valueOf())
        } else {
          LocalStorage.set(
            LocalStorageKey.VISIBLE_DATE,
            startDayJs
              .set('hour', nowDayJs.hour())
              .set('minute', 0)
              .set('second', 0)
              .add(1, 'hour')
              .valueOf()
          )
        }
      }
    },
    [calendar, auth.firstGetChangesFinished, calendarSync, onDateRange]
  )

  //update profiles each time group presented
  useEffect(() => {
    if (
      props.group &&
      props.group.Participants &&
      LocalStorage.get(LocalStorageKey.USER_ID)
    )
      getProfilesForParticipants(Object.keys(props.group.Participants || {}))
  }, [props.groupID])

  const [loadingEvents, setLoadingEvents] = useState(false)
  const [lastAppSync, setLastAppSync] = useState<string | null>(() =>
    LocalStorage.get(LocalStorageKey.LAST_APP_SYNC)
  )

  // Listen for LAST_APP_SYNC localStorage changes (useful for guest users and cross-tab sync)
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (
        e.key === LocalStorageKey.LAST_APP_SYNC ||
        e.key === LocalStorageKey.LAST_FOCUS_SYNC
      ) {
        setLastAppSync(e.newValue)
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  useEffect(() => {
    if (
      !auth.isAuth &&
      isGuest() &&
      dateRange &&
      (props.groupID || (props.groupIds?.length ?? 0) > 0) &&
      !loadingEvents
    ) {
      setLoadingEvents(true)
      let start = dateRange.leftBound
      let end = dateRange.rightBound

      // Only override the range if we are in a List View.
      // This ensures standard views (Month/Week) keep their native behavior,
      // while List View gets the specific buffer defined in ListView.tsx.
      if (
        calendar.view === CalendarRange.LISTWEEK ||
        calendar.view === CalendarRange.LISTDAY
      ) {
        const customRange = calculateListViewRange(
          calendar.view,
          dayjs.unix(dateRange.leftBound).toISOString()
        )
        start = customRange.start.unix()
        end = customRange.end.unix()
      }

      getEventsForGroup(props.groupID, start, end, props.groupIds)
        .then((eventsAndGroupData) => {
          Logger.blue('guest group response', eventsAndGroupData)
          calendar.onGroupServer(
            (props.groupIds?.length ?? 0) > 0
              ? ''
              : (eventsAndGroupData.groups[0]._id ?? '')
          )
          setTimeout(() => {
            setLoadingEvents(false)
          }, 500)
        })
        .catch((e) => {
          setTimeout(() => {
            setLoadingEvents(false)
          }, 500)

          Logger.red('guest group error', e)
        })
    }
  }, [dateRange, isGuest() ? lastAppSync : null])

  const queryParams = new URLSearchParams(location.search)
  const predefinedView = queryParams.get('view') as CalendarRange
  const oneDayAtATime = queryParams.get('oneDateAtTime') === '1'

  useEffect(() => {
    if (oneDayAtATime) {
      calendar.onView(CalendarRange.LISTDAY)
    }
  }, [])

  const [updateEventError, setUpdateEventError] = useState<string | undefined>()

  const [droppedEventData, onDroppedEventData] = useState<
    DropEventData | undefined
  >(undefined)

  async function updateEventData(
    newEvent: EventApi,
    oldEventModel: EventApi,
    publicId: string
  ) {
    const oldEvent = oldEventModel.extendedProps.eventModel
    LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)

    const showingEvent = LocalStorage.get(LocalStorageKey.VISIBLE_EVENT)

    Logger.pink('dropped', newEvent, oldEventModel)
    Logger.pink(
      'will set',
      LocalStorage.get(LocalStorageKey.VISIBLE_EVENT) !== null
    )

    if ((newEvent.allDay ? '1' : '0') !== oldEvent.AllDay) {
      ;(calendar.ref as any).current?.getApi().getEventById(publicId)?.remove()
    }

    if (oldEvent.someday === '1') {
      LocalStorage.set(
        LocalStorageKey.SOMEDAY_DATE,
        (newEvent.start?.valueOf() ?? 0) / 1000
      )
      LocalStorage.set(
        LocalStorageKey.SOMEDAY_ALL_DAY,
        newEvent.allDay ? '1' : '0'
      )
      return
    }

    if (showingEvent != null) {
      //only in case event was opened previously
      if (showingEvent.includes(oldEvent._id)) {
        LocalStorage.set(
          LocalStorageKey.VISIBLE_EVENT,
          `${oldEvent._id}${newEvent?.start?.valueOf()}`
        )
      } else {
        LocalStorage.remove(LocalStorageKey.VISIBLE_EVENT)
      }
    }
    const oldLocal = await localEventById(oldEvent._id)
    if (!oldLocal) {
      console.log('not found')
      return
    }
    const oldStart = (oldEventModel.start?.valueOf() ?? 0).toString()
    const oldEnd = (oldEventModel.end?.valueOf() ?? 0).toString()

    const newAlldayStart = dayjs
      .utc(dayjs(newEvent.startStr))
      .add(1, 'day')
      .startOf('day')
    const newAlldayEnd = newEvent.endStr
      ? dayjs.utc(dayjs(newEvent.endStr)).startOf('day')
      : newAlldayStart

    const start = newEvent.allDay
      ? newAlldayStart.unix().toString()
      : `${(newEvent.start?.valueOf() ?? 0) / 1000}`
    const end = newEvent.allDay
      ? newAlldayEnd.unix().toString()
      : (
          (newEvent.end ?? newEvent.start ?? new Date())?.valueOf() / 1000 +
          (newEvent.end ? 0 : 60 * 60)
        ).toString()

    function updateLocalEvent() {
      return Database.write(async () => {
        return oldLocal.update((local) => {
          if (newEvent.start) {
            if (local.syncStatus != 'deleted') {
              local.StartDate = start
              local.EndDate = end
              local.LastUpdate = dayjs().unix().toString()
              local.AllDay = newEvent.allDay ? '1' : '0'
              local.TimeZoneNameID = newEvent.allDay
                ? 'UTC'
                : oldEventModel.allDay
                  ? getDefaultTimezone()
                  : (oldLocal.TimeZoneNameID ?? getDefaultTimezone())
            }
          }
        })
      })
    }

    if (oldLocal.syncStatus === 'deleted') return

    if (oldEvent && !oldEvent.Recurrence?.Unit) {
      updateLocalEvent().then(async (updatedLocal) => {
        if (
          updatedLocal._id.length > 0 ||
          (updatedLocal.local_id?.length ?? 0) > 0
        ) {
          ;(calendar.ref as any).current?.getApi().scrollToTime(
            dayjs(newEvent.start)
              .tz(
                (oldEvent.TimeZoneNameID?.length ?? 0) > 0
                  ? oldEvent.TimeZoneNameID
                  : getDefaultTimezone()
              )
              .format('HH:mm:ss')
          )
          await updateEventOnServer(
            updatedLocal,
            Database.toServerObject<EventDoc>(updatedLocal) as EventDoc
          ).catch((e) => {
            if (e instanceof AxiosError) {
              if (e.response?.status === 400) {
                console.error(e)
              } else if (e.response?.status === 403) {
                setUpdateEventError(parseErrorToMessage(e, updatedLocal._id))
                Database.write(async () => {
                  updatedLocal.update((local) => {
                    local.StartDate = oldStart
                    local.EndDate = oldEnd
                  })
                }).then(() => {
                  ;(calendar.ref as any).current?.getApi().scrollToTime(
                    dayjs(Number(oldStart) * 1000)
                      .tz(
                        isTrulyEmpty(oldEvent.TimeZoneNameID)
                          ? getDefaultTimezone()
                          : oldEvent.TimeZoneNameID
                      )
                      .format('HH:mm:ss')
                  )
                })
              }
            }
          })
        }
      })
    } else {
      const data: DropEventData = {
        newEvent,
        oldEvent,
        oldAllDay: oldEvent.AllDay === '1',
        oldStart: Number(oldStart),
        oldEnd: Number(oldEnd),
        oldTimeZone: isTrulyEmpty(oldEvent.TimeZoneNameID)
          ? getDefaultTimezone()
          : oldEvent.TimeZoneNameID,
        newStart: Number(start),
        newEnd: Number(end)
      }
      onDroppedEventData(data)
    }
  }

  const [cachedRevert, setCachedRevert] = useState<() => void>()

  useEffect(() => {
    handleSaveRecurringEvent(RECUR_SAVE_TYPE.THIS)
  }, [droppedEventData])

  const dropCallback = useCallback(
    (arg: EventDropArg) => {
      if (showSyncIfNeeded()) {
        return
      }
      setCachedRevert(() => arg.revert)
      updateEventData(arg.event, arg.oldEvent, arg.oldEvent._def.publicId)
    },
    [showSyncIfNeeded]
  )

  const resizeCallback = useCallback(
    (arg: EventResizeDoneArg) => {
      if (showSyncIfNeeded()) {
        return
      }

      updateEventData(arg.event, arg.oldEvent, arg.oldEvent._def.publicId)
    },
    [showSyncIfNeeded]
  )

  const [showRecurrenceDialog, setShowRecurrenceDialog] = useState(false)
  const handleCloseRecurringSave = () => {
    setShowRecurrenceDialog(false)
  }

  const handleSaveRecurringEvent = async (type: RECUR_SAVE_TYPE) => {
    Logger.pink('handle on calendar type; data', type, droppedEventData)

    if (droppedEventData) {
      const newStart = dayjs(droppedEventData.newEvent.start)
      const newEnd = droppedEventData.newEvent.end
        ? dayjs(droppedEventData.newEvent.end)
        : newStart.add(1, 'hour')
      const isAllDay = droppedEventData.newEvent.allDay
      const oldData = Database.toServerObject<EventDoc>(
        droppedEventData.oldEvent
      )

      const originalEvent = await localEventByLocalId(
        droppedEventData.oldEvent.id
      )

      const newValues: EventDoc = {
        ...oldData,
        id: undefined,
        StartDate: `${droppedEventData.newStart}`,
        EndDate: `${droppedEventData.newEnd}`,
        AllDay: isAllDay ? '1' : '0',
        TimeZoneNameID:
          droppedEventData.oldEvent.AllDay === '1'
            ? getDefaultTimezone()
            : droppedEventData.oldEvent.TimeZoneNameID,
        SupplementaryGroupsIDs: oldData.SupplementaryGroupsIDs ?? []
      }

      calendarSync
        .syncEventWithThirdParty(
          Number(droppedEventData.oldStart),
          Number(droppedEventData.oldEnd),
          newValues,
          originalEvent,
          false,
          true,
          (error) => {
            setUpdateEventError(error)

            if (cachedRevert) {
              cachedRevert()
              setCachedRevert(undefined)
            }
          },
          type,
          false
        )
        .then(() => {
          onDroppedEventData(undefined)
        })
        .catch((e) => {
          Logger.red('syncEventWithThirdParty error', e)

          // Revert the event to its original state in the database
          Database.write(async () => {
            if (originalEvent && typeof originalEvent.update === 'function') {
              originalEvent.update((local) => {
                local.StartDate = `${droppedEventData.oldStart / 1000}`
                local.EndDate = `${droppedEventData.oldEnd / 1000}`
                local.AllDay = droppedEventData.oldAllDay ? '1' : '0'
                local.TimeZoneNameID = droppedEventData.oldTimeZone
              })
            }
          }).then(() => {
            // Clear the dropped event data to reset the UI
            onDroppedEventData(undefined)

            // Force FullCalendar to refetch events and re-render
            ;(calendar.ref as any).current?.getApi()?.refetchEvents()

            // Optionally show an error message
            setUpdateEventError(
              e instanceof AxiosError
                ? parseErrorToMessage(e, originalEvent?._id ?? '')
                : t('failedToUpdateEvent')
            )
          })
        })
    }

    setShowRecurrenceDialog(false)
  }

  const [eventsForCalendar, setEventsForCalendar] = useState<
    { fcEvents: EventInput[]; filteredEvents: EventDoc[] } | undefined
  >(undefined)

  // Memoize filtered events computation for better performance
  const filteredEvents = useMemo(() => {
    const visibleAreaStart = dayjs(
      LocalStorage.get(LocalStorageKey.VISIBLE_FROM) ?? ''
    )
    const visibleAreaEnd = dayjs(
      LocalStorage.get(LocalStorageKey.VISIBLE_TO) ?? ''
    )
    const currentGroup = LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? ''
    const archivedGroups = getArchivedGroups(props.userSettings)
    const deletedGroups = getDeletedGroups(props.userSettings)

    return props.events.filter((event) => {
      const isAllSupplementaryArchived = (
        event.SupplementaryGroupsIDs ?? [event.GroupID ?? '']
      )?.every((id) => archivedGroups.includes(id))

      const isShowingOnlyMyEventsInGroup =
        props.userSettings?.GroupsSettings?.[event.GroupID ?? '']
          ?.ShoWOnlyEventsIOwn === '1'

      // Archived groups check
      if (
        ((archivedGroups.includes(event.GroupID ?? '') &&
          isAllSupplementaryArchived) ||
          deletedGroups.includes(event.GroupID ?? '')) &&
        event.GroupID !== currentGroup
      )
        return false

      // Status check
      if (
        String(event.Status) === EventStatus.DELETED ||
        String(event.Status) === EventStatus.REMOVED
      )
        return false

      // Time-related checks
      if (!isSomeDayInstance(event) && !isLateInstance(event)) {
        if (
          !isEventRecurrenceInstanceValid(event, visibleAreaStart) &&
          !isEventInstanceWithinTimePeriod(
            event,
            visibleAreaStart,
            visibleAreaEnd
          )
        ) {
          return false
        }
      }

      const suppGroupStates = []

      for (const groupId of event.SupplementaryGroupsIDs ?? []) {
        const groupState = isGroupHidden(props.userSettings, groupId)
        suppGroupStates.push(
          groupState || isGroupArchived(props.userSettings, groupId)
        )
      }

      const isAllHiddenOnAllCalendars = suppGroupStates.every(
        (state) => state === true
      )

      // Group visibility check
      if (
        currentGroup !== event.GroupID &&
        isGroupHidden(props.userSettings, event.GroupID ?? '') &&
        isAllHiddenOnAllCalendars &&
        !isInIframe()
      ) {
        return false
      }

      // Selected group check
      if (props.showOnlySelectedGroup) {
        if (
          event.GroupID !== props.groupID &&
          (props.groupIds?.length ?? 0) === 0 &&
          !props.readOnly
        ) {
          return false
        } else if ((props.groupIds?.length ?? 0) > 0) {
          if (!props.groupIds!.includes(event.GroupID ?? '')) {
            return false
          } else return true
        }
      }

      // LocalStorage group check
      const selectedGroup = currentGroup

      if (!isTrulyEmpty(selectedGroup) && (props.groupIds?.length ?? 0) === 0) {
        const groupSetting =
          props.userSettings?.GroupsSettings?.[selectedGroup ?? '']
        if (
          groupSetting?.ShoWEventsFromOtherGroups === '0' ||
          props.embedMode
        ) {
          if (
            event.GroupID !== selectedGroup &&
            event.SupplementaryGroupsIDs?.find(
              (groupid) => groupid === selectedGroup
            ) === undefined
          ) {
            return false
          }
        }
      }

      if (
        isShowingOnlyMyEventsInGroup &&
        event.OwnerID !== LocalStorage.get(LocalStorageKey.USER_ID)
      )
        return false

      if ((props.groupIds?.length ?? 0) !== 0) {
        // meaning we want to show only specific groups
        if (!props.groupIds?.includes(event.GroupID ?? '')) {
          return false
        }
      }

      return true
    })
  }, [
    props.events,
    props.userSettings?._rev,
    props.showOnlySelectedGroup,
    props.groupID,
    props.groupIds,
    props.embedMode
  ])

  const isOnline = useNetworkStatus()

  useEffect(() => {
    const currentGroup = LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? ''
    const groupCache = new Map<string, GroupDoc | null>() // Cache for group data

    Promise.all(
      filteredEvents.map(async (event) => {
        const groupId = event.GroupID ?? ''
        if (!groupCache.has(groupId)) {
          // Query the database only if the group is not in the cache
          const group = await provideReferenceGroup(
            event,
            props.userSettings,
            currentGroup,
            LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
          ).then((group) => localGroupById(group ?? ''))
          groupCache.set(groupId, group) // Cache the result
        }

        // Use the cached group data
        event.referenceGroup = {
          ...Database.toServerObject(groupCache.get(groupId))
        } as GroupDoc
      })
    ).then(() => {
      setEventsForCalendar({
        fcEvents: mapEventsToCalendar(
          filteredEvents,
          props.groups,
          props.account,
          getDefaultTimezone(),
          isGuest(),
          LocalStorage.get(LocalStorageKey.SOMEDAY_DATE) ?? '',
          LocalStorage.get(LocalStorageKey.SOMEDAY_ALL_DAY) ?? '',
          LocalStorage.get(LocalStorageKey.USER_ID) ?? '',
          LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? ''
        ),
        filteredEvents: filteredEvents
      })
    })
  }, [
    filteredEvents,
    props.groups,
    props.account,
    props.userSettings,
    isOnline
  ])

  const dateSelect = useCallback(
    (arg: DateSelectArg) => {
      Logger.pink('DateSelect', arg)

      if (showSyncIfNeeded()) {
        return
      }

      if (showCanOperateEventsIfNeeded()) {
        return
      }

      let start = dayjs(arg.startStr)
      let end = dayjs(arg.endStr)

      // check that length bigger than 1 day
      if (
        end.diff(start, 'day') === 1 &&
        calendar.view === CalendarRange.MONTH
      ) {
        return
      }

      if (end.diff(start, 'minute') === 15) {
        LocalStorage.set(LocalStorageKey.IGNORE_EMPTY_CLICK, '1')
      }

      if (arg.allDay) {
        start = dayjs.utc(arg.startStr).startOf('day')
        end = dayjs.utc(arg.endStr).startOf('day')
      }

      addEventToDate(
        EventProperties.EVENT_FROM_SCREEN,
        props.group?._id,
        start.unix(),
        end.unix(),
        arg.allDay,
        props.userSettings
      ).then((e) => {
        Logger.orange('added', e)
        ;(calendar.ref as any).current?.getApi().unselect()
      })
    },
    [
      showSyncIfNeeded,
      showCanOperateEventsIfNeeded,
      calendar,
      props.group,
      props.userSettings
    ]
  )

  const [haveActiveCalendar, setHaveActiveCalendar] = useState(false)
  const [showEventAddingNotPossible, onShowEventAddingNotPossible] =
    useState(false)

  const landlineCheck = useLandlineCheck()

  const emptyDateClick = useCallback(
    async (arg: DateClickArg) => {
      Logger.blue('EmptyDateClick', arg.date.valueOf(), arg)
      if (isUserOutOfTierBasedOnLandline(props.account)) {
        landlineCheck.onShowOutOfTierBasedOnLandline(true)
        return
      }
      if (showSyncIfNeeded()) {
        return
      }
      if (LocalStorage.get(LocalStorageKey.IGNORE_EMPTY_CLICK) === '1') {
        LocalStorage.remove(LocalStorageKey.IGNORE_EMPTY_CLICK)
        return
      }
      if (LocalStorage.get(LocalStorageKey.MORE_EVENTS_OPENED) === '1') return

      if (isGroupcalApp()) {
        if (isGuest()) {
          return
        } else if (!haveActiveCalendar || props.groups?.length == 0) {
          onShowEventAddingNotPossible(true)
          return
        }
      }

      function clearScreen() {
        LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
      }

      if (LocalStorage.get(LocalStorageKey.USER_ID)) {
        if (!LocalStorage.get(LocalStorageKey.VISIBLE_EVENT)) {
          if (isOutOfTier) {
            onShowOutOfTierDialog(true)
          } else if (showCanOperateEventsIfNeeded()) {
            // do nothing
          } else if (userRemoved) {
            setShowUserRemovedDialog(true)
          } else if (
            !LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) ||
            LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) === '0'
          ) {
            const allDay = arg.view.type === 'dayGridMonth' ? false : arg.allDay

            let start = dayjs(arg.date).minute(0)

            if (arg.view.type === 'dayGridMonth') {
              start = start.set('hour', 12)
            }

            let end = start.add(1, 'hour')

            if (allDay) {
              start = dayjs.utc(arg.dateStr).startOf('day')
              end = dayjs.utc(arg.dateStr).startOf('day')
            }

            if (LocalStorage.get(LocalStorageKey.USER_ID)) {
              addEventToDate(
                EventProperties.ADD_EVENT_FROM_LONG_TAP,
                props.group?._id,
                start.unix(),
                end.unix(),
                arg.view.type === 'dayGridMonth' ? false : arg.allDay,
                props.userSettings
              )
            }
          }
        } else {
          clearScreen()
        }
      }
    },
    [
      props.account,
      props.group,
      props.groups,
      props.userSettings,
      landlineCheck,
      showSyncIfNeeded,
      showCanOperateEventsIfNeeded,
      haveActiveCalendar,
      isOutOfTier,
      userRemoved
    ]
  )

  const handleAddEvent = useCallback(
    async (startEnd: StartEndEvent) => {
      if (isUserOutOfTierBasedOnLandline(props.account)) {
        landlineCheck.onShowOutOfTierBasedOnLandline(true)
        return
      }

      if (showSyncIfNeeded()) {
        return
      }

      if (showCanOperateEventsIfNeeded()) {
        return
      }

      if (LocalStorage.get(LocalStorageKey.VISIBLE_EVENT)) {
        if (isCypress()) {
          LocalStorage.remove(LocalStorageKey.VISIBLE_EVENT)
        } else {
          return
        }
      }

      if (
        isGroupcalApp() &&
        (!haveActiveCalendar || props.groups?.length == 0)
      ) {
        if (isGuest()) {
          return
        } else {
          onShowEventAddingNotPossible(true)
        }
        return
      }

      if (isOutOfTier) {
        onShowOutOfTierDialog(true)
      } else if (userRemoved) {
        showUserRemoved()
      } else {
        calendar.onScrollToTime(
          dayjs(startEnd.start * 1000).tz(getDefaultTimezone())
        )

        await addEventToDate(
          EventProperties.EVENT_FROM_SCREEN,
          props.group?._id,
          startEnd.start,
          startEnd.end,
          false,
          props.userSettings
        )
      }
    },
    [
      props.account,
      props.group,
      props.groups,
      props.userSettings,
      landlineCheck,
      showSyncIfNeeded,
      showCanOperateEventsIfNeeded,
      haveActiveCalendar,
      isOutOfTier,
      userRemoved,
      showUserRemoved,
      calendar
    ]
  )

  useEffect(() => {
    isUserHaveGroupToAddEvents().then((groupId) => {
      if (groupId) {
        setHaveActiveCalendar(true)
      } else {
        setHaveActiveCalendar(false)
      }
    })
  }, [props.groups])

  // Memoize expensive calculations
  const initialCalendarView = useMemo(() => {
    return CALENDAR_VIEW[props.defaultView ?? predefinedView ?? calendar.view]
  }, [props.defaultView, predefinedView, calendar.view])

  const calendarEvents = useMemo(() => {
    return calendar.view === CalendarRange.LISTWEEK ||
      calendar.view === CalendarRange.LISTDAY ||
      calendar.view === CalendarRange.CARDS
      ? []
      : (eventsForCalendar?.fcEvents ?? [])
  }, [calendar.view, eventsForCalendar?.fcEvents])

  const listViewStyle = useMemo(
    () => ({
      backgroundColor: theme.palette.background.default,
      position: 'absolute' as const,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    }),
    []
  )

  return (
    <Styled.CalendarView>
      <Styled.CalendarViewScrollContainer>
        <Styled.CalendarViewScroll data-calendar={calendar.view}>
          <TfmFullCalendar
            ignoreDim={props.showOnlySelectedGroup}
            userSettings={props.userSettings}
            dateSelect={dateSelect}
            embedMode={props.embedMode}
            account={props.account}
            group={props.group}
            dropCallback={dropCallback}
            resizeCallback={resizeCallback}
            dayNameFormat={props.dayNameFormat}
            initialView={initialCalendarView}
            events={calendarEvents}
            calRef={calendar.ref}
            onDatesSet={onDatesSet}
            emptyDateClick={emptyDateClick}
            handleAddEvent={handleAddEvent}
          />

          {calendar.view === CalendarRange.LISTWEEK ||
          calendar.view === CalendarRange.LISTDAY ? (
            <div style={listViewStyle}>
              {eventsForCalendar?.filteredEvents && (
                <ListView
                  embedMode={props.embedMode}
                  groupId={props.group?._id}
                  userSettings={props.userSettings}
                  dayNameFormat={props.dayNameFormat}
                  handleAddEvent={handleAddEvent}
                  events={eventsForCalendar?.filteredEvents}
                  group={props.group}
                  loadingEvents={loadingEvents}
                />
              )}
            </div>
          ) : (
            <></>
          )}

          {calendar.view === CalendarRange.CARDS ? (
            <div style={listViewStyle}>
              {eventsForCalendar?.filteredEvents && (
                <GalleryView
                  embedMode={props.embedMode}
                  groupId={props.group?._id}
                  userSettings={props.userSettings}
                  account={props.account}
                  events={eventsForCalendar?.filteredEvents}
                  group={props.group}
                  loadingEvents={loadingEvents}
                  showGroupTag={
                    (isTrulyEmpty(props.group?._id) &&
                      isTrulyEmpty(calendar.groupServerID)) ||
                    (props.groupIds?.length ?? 0) !== 0
                  }
                />
              )}
            </div>
          ) : (
            <></>
          )}
        </Styled.CalendarViewScroll>
      </Styled.CalendarViewScrollContainer>
      {props.readOnly ? (
        <></>
      ) : (
        <AddEventButton
          handleAddEvent={handleAddEvent}
          onShowOutOfTier={onShowOutOfTierDialog}
          showUserBlockedFromAdding={showCanAddEventsDialog}
          userRemoved={userRemoved}
          showUserRemoved={showUserRemoved}
          groupOutOfTier={isOutOfTier}
          {...props}
        />
      )}
      {props.readOnly || props.embedMode ? (
        <></>
      ) : (
        <Box
          position={'absolute'}
          bottom={20}
          right={i18n.dir() === 'ltr' ? 16 : undefined}
          left={i18n.dir() === 'ltr' ? undefined : 16}
          zIndex={10001}
        >
          <ChatbaseButton />
        </Box>
      )}
      {userRemoved && showUserRemovedDialog && (
        <ConfirmationDialog
          rightButtonHidden
          title={`${t('youDontHavePermissions')}`}
          content={''}
          leftButton={'OK'}
          leftButtonColor={APP_COLOR}
          handleLeftButton={hideUserRemovedDialog}
          handleClose={hideUserRemovedDialog}
          open={showUserRemovedDialog}
        />
      )}
      {userCannotAddEvents && (
        <ConfirmationDialog
          rightButtonHidden
          title={t('cantDoThat')}
          content={t('onlyCalendarAdmins')}
          leftButton={t('ok')}
          leftButtonColor={APP_COLOR}
          handleLeftButton={hideCanAddEventsDialog}
          handleClose={hideCanAddEventsDialog}
          open={userCannotAddEvents}
        />
      )}
      {showOutOfTierDialog && (
        <OutOfTierDialog
          flow={BlockedFlow.addItem}
          account={props.account}
          group={props.group}
          setOpen={onShowOutOfTierDialog}
          opened={showOutOfTierDialog}
        />
      )}
      {showRecurrenceDialog && (
        <RecurrentActionDialog
          disableOthers
          handleLeftButton={() => {
            Database.write(async () => {
              if (typeof droppedEventData?.oldEvent.update === 'function') {
                droppedEventData?.oldEvent.update((local) => {
                  local.StartDate = `${droppedEventData?.oldStart}`
                  local.EndDate = `${droppedEventData?.oldEnd}`
                  local.AllDay = droppedEventData?.oldAllDay ? '1' : '0'
                  local.TimeZoneNameID = droppedEventData.oldTimeZone
                })
              }
            })
          }}
          default={RECUR_SAVE_TYPE.ALL}
          open={showRecurrenceDialog}
          handleClose={handleCloseRecurringSave}
          handleSaveRecurringEvent={handleSaveRecurringEvent}
        />
      )}
      {updateEventError && (
        <ConfirmationDialog
          title={`${t('cantDoThat')}`}
          content={updateEventError}
          leftButtonHidden
          rightButton={`${t('ok')}`}
          handleClose={() => {
            setUpdateEventError(undefined)
          }}
          open={updateEventError != undefined}
        />
      )}
      {showEventAddingNotPossible && (
        <ConfirmationDialog
          title={''}
          content={isGuest() ? t('toAddEventsGuest') : t('toAddEvents')}
          leftButtonHidden
          rightButton={`${t('ok')}`}
          rightButtonColor={APP_COLOR}
          handleRightButton={() => {
            onShowEventAddingNotPossible(false)
          }}
          open
          handleClose={() => {}}
        />
      )}
      <TierEndDialog account={props.account} />
      {showCalendarSync && (
        <ResyncCalendarDialog
          isOpen={showCalendarSync}
          setOpen={onShowCalendarSync}
          group={props.group}
        />
      )}
    </Styled.CalendarView>
  )
}
export function isEventRecurrenceInTimePeriod(
  event: EventDoc,
  visibleAreaStart: Dayjs,
  visibleAreaEnd: Dayjs
): boolean {
  const rruleString = mapRecurrency(event, true)
  if (!rruleString) return false

  const rrule = rrulestr(rruleString)
  const occurrences = rrule.between(
    visibleAreaStart.toDate(),
    visibleAreaEnd.toDate(),
    true
  )

  return occurrences.length > 0
}

export function isEventWithinTimePeriod(
  event: EventDoc,
  visibleAreaStart: Dayjs,
  visibleAreaEnd: Dayjs
): boolean {
  return isEventInstanceWithinTimePeriod(
    event,
    visibleAreaStart,
    visibleAreaEnd
  )
}

interface TierEndDialogProps {
  account: AccountDoc
}

function TierEndDialog(props: TierEndDialogProps) {
  const payment = usePayment()

  const [trialProduct, onTrialProduct] = useState<AccountProduct | undefined>(
    undefined
  )

  function checkTrialDialog() {
    const trialProduct = exhaustedProduct(props.account)

    if (
      trialProduct &&
      props.account?.Products?.filter((product) => product.Status != 'trialing')
        .length === 0 // meaning we don't have any other products
    ) {
      const delta = dayjs().diff(
        dayjs(Number(trialProduct.ExpiryDate) * 1000),
        'month'
      )

      if (
        delta < 3 &&
        LocalStorage.get(LocalStorageKey.EXPIRY_DIALOG_SHOWN) != null &&
        LocalStorage.get(LocalStorageKey.EXPIRY_DIALOG_SHOWN) != '1'
      ) {
        LocalStorage.set(LocalStorageKey.EXPIRY_DIALOG_SHOWN, '1')
        onTrialProduct(trialProduct)
        onShowDialog(trialProduct != undefined)
      }
    }
  }

  const [showDialog, onShowDialog] = useState(false)
  //each minute check if we have expired product
  useEffect(() => {
    checkTrialDialog()

    const interval = setInterval(() => {
      checkTrialDialog()
    }, 60000)

    return () => clearInterval(interval)
  }, [props.account])

  const closeDialog = () => {
    onShowDialog(false)
  }

  const openPurchase = () => {
    payment.showPaymentDialog(null)
    closeDialog()
  }

  return (
    <>
      {trialProduct && showDialog && (
        <ConfirmationDialog
          title={t('trialExpired')}
          content={t('yourTrialExpirationDate', {
            date: dayjs(Number(trialProduct.ExpiryDate) * 1000)
              .add(10, 'minute')
              .format('dddd, DD MMM YYYY, HH:mm')
          })}
          rightButton={`${t('purchaseAPlan')}`}
          leftButton={`${t('donwgradeToBasic')}`}
          leftButtonColor={'black'}
          rightButtonColor={APP_COLOR}
          handleLeftButton={closeDialog}
          handleRightButton={openPurchase}
          open={showDialog}
          handleClose={() => {}}
        />
      )}
    </>
  )
}

export interface TfmFullCalendarProps {
  dateSelect: ((arg: DateSelectArg) => void) | undefined
  initialView: string
  height?: number
  emptyDateClick?: (arg: DateClickArg) => void
  onDatesSet?: (datesSetArg: DatesSetArg) => void
  events: EventSourceInput
  calRef?: Ref<FullCalendar>
  dayNameFormat?: string
  dropCallback: (arg: EventDropArg) => void
  resizeCallback: (arg: EventResizeDoneArg) => void
  account: AccountDoc
  group: GroupDoc
  userSettings: UserSettingsDoc
  handleAddEvent: (startEnd: StartEndEvent) => void
  ignoreDim?: boolean
  embedMode?: boolean
}

export function TfmFullCalendar(props: TfmFullCalendarProps) {
  useEffect(() => {
    const divsToAnimate = document.querySelectorAll('.animate-opacity')
    divsToAnimate.forEach((div) => div.classList.add('animate-opacity'))
  }, [])

  const appSettings = useAppSettings()

  const targetDivRef = React.useRef<HTMLDivElement>(null)

  function firstDayForFullCalendar(
    firstDayOfTheWeek: number
  ): number | undefined {
    switch (firstDayOfTheWeek) {
      case FIRST_DAYS.SUNDAY:
        return 0
      case FIRST_DAYS.MONDAY:
        return 1

      default:
        return 0
    }
  }

  // Create a Map to store roots
  const roots = new Map()

  const calendar = useCalendar()

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [moreEvents, setMoreEvents] = useState<EventSegment[] | undefined>(
    undefined
  )

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    const handleResize = () => {
      setAnchorEl(null)
      // Add your resize logic here
    }

    window.addEventListener('resize', handleResize)

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const { closePopover, pointTo } = useEventPopover()
  const [eventForMenu, setEventForMenu] = useState<EventDoc | null>(null)

  const [contextMenuPosition, setContextMenuPosition] = useState<{
    x: number
    y: number
  } | null>(null)
  const [selectedEventForMenu, setSelectedEventForMenu] = useState<{
    event: EventDoc
    instanceStart: number
    instanceEnd: number
  } | null>(null)

  const handleContextMenu = (
    event: React.MouseEvent,
    eventDoc: EventDoc,
    instanceStart: number,
    instanceEnd: number
  ) => {
    event.preventDefault()
    setContextMenuPosition({ x: event.clientX, y: event.clientY })
    setSelectedEventForMenu({
      event: eventDoc,
      instanceStart,
      instanceEnd
    })
  }

  const handleCloseContextMenu = () => {
    setContextMenuPosition(null)
    setSelectedEventForMenu(null)
    LocalStorage.remove(LocalStorageKey.DRAGGING)
  }

  const { setIsContextMenuOpen } = useEventActions()

  return (
    <>
      {contextMenuPosition && (
        <EventContextMenu
          x={contextMenuPosition.x}
          y={contextMenuPosition.y}
          onClose={handleCloseContextMenu}
          event={eventForMenu}
          group={props.group}
          instanceStart={selectedEventForMenu?.instanceStart ?? 0}
          instanceEnd={selectedEventForMenu?.instanceEnd ?? 0}
        />
      )}
      {anchorEl && (
        <TFloatingPopover
          id={id ?? ''}
          open={open}
          defaultPlacement="right"
          fallbackPlacements={['left']}
          anchorElement={anchorEl}
          closeOnTouchOutside={false}
          onOutsideClick={() => {
            if (LocalStorage.get(LocalStorageKey.VISIBLE_EVENT) === null) {
              setAnchorEl(null)
              closePopover()
            }
          }}
          onClose={handlePopoverClose}
          content={
            <EventsListPopupContent
              events={moreEvents ?? []}
              eventDrawer={(eventSegment) => {
                const { instanceStart, instanceEnd } = getEventInstanceTimes(
                  eventSegment.event.startStr,
                  eventSegment.event.endStr,
                  eventSegment.event.allDay,
                  eventSegment.event.extendedProps?.eventModel as EventDoc
                )
                return (
                  <Box
                    sx={{
                      marginRight: () => {
                        if (
                          eventLengthInDays(
                            eventSegment.event.extendedProps
                              ?.eventModel as EventDoc
                          ) > 1 &&
                          !eventSegment.isEnd &&
                          !eventSegment.isStart
                        )
                          return '0.2rem'
                        else if (
                          eventLengthInDays(
                            eventSegment.event.extendedProps
                              ?.eventModel as EventDoc
                          ) > 1 &&
                          eventSegment.isStart
                        )
                          return '0.2rem'
                        else return '1rem'
                      },
                      marginLeft: () => {
                        if (
                          eventLengthInDays(
                            eventSegment.event.extendedProps
                              ?.eventModel as EventDoc
                          ) > 1 &&
                          !eventSegment.isEnd &&
                          !eventSegment.isStart
                        )
                          return '0.2rem'
                        else if (
                          eventLengthInDays(
                            eventSegment.event.extendedProps
                              ?.eventModel as EventDoc
                          ) > 1 &&
                          eventSegment.isEnd
                        )
                          return '0.2rem'
                        else return '1rem'
                      }
                    }}
                  >
                    <Event
                      embedMode={props.embedMode}
                      dynamicDesign
                      isEnd={eventSegment.isEnd}
                      alwaysFullSize={false}
                      ignoreDim={props.ignoreDim}
                      onEventDetailsClose={() => {}}
                      isStart={eventSegment.isStart}
                      instanceStart={instanceStart}
                      instanceEnd={instanceEnd}
                      event={eventSegment.event?.extendedProps?.eventModel}
                      title={eventSegment.event.extendedProps?.eventModel.Text}
                    />
                  </Box>
                )
              }}
            />
          }
        />
      )}
      <FullCalendar
        plugins={[
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          rrulePlugin,
          listPlugin,
          momentTimezonePlugin,
          adaptivePlugin
        ]}
        views={{
          galleryMonth: {
            type: 'dayGrid',
            duration: { months: 1 }
          }
        }}
        fixedWeekCount={false}
        schedulerLicenseKey={process.env.REACT_APP_FC_KEY}
        timeZone={appSettings.timeZone}
        initialView={props.initialView}
        firstDay={firstDayForFullCalendar(appSettings.firstDayOfTheWeek)}
        height={'inherit'}
        headerToolbar={false}
        scrollTime={dayjs().format('HH:mm:ss')}
        snapDuration={{ minutes: 15 }}
        eventStartEditable
        eventResizableFromStart
        editable={
          !isGuest() &&
          (isTrulyEmpty(LocalStorage.get(LocalStorageKey.SELECTED_GROUP)) ||
            isGroupNotAvailableForEventChanges(props.group, props.account) ===
              false)
        }
        droppable={
          !isGuest() &&
          (isTrulyEmpty(LocalStorage.get(LocalStorageKey.SELECTED_GROUP)) ||
            isGroupNotAvailableForEventChanges(props.group, props.account) ===
              false)
        }
        selectable={
          !isGuest() &&
          (isTrulyEmpty(LocalStorage.get(LocalStorageKey.SELECTED_GROUP)) ||
            isGroupNotAvailableForEventChanges(props.group, props.account) ===
              false)
        }
        eventDrop={(arg) => {
          console.log('dropped', arg)
          props.dropCallback(arg)
        }}
        selectOverlap
        selectMirror
        selectMinDistance={5}
        select={props.dateSelect}
        eventResize={props.resizeCallback}
        dateClick={props.emptyDateClick}
        moreLinkContent={(e) => {
          return <MoreLink num={e.num} />
        }}
        moreLinkClick={(e) => {
          setMoreEvents(e.hiddenSegs)
          setAnchorEl(e.jsEvent.currentTarget as HTMLElement)
        }}
        moreLinkWillUnmount={() => {
          setAnchorEl(null)
          setMoreEvents(undefined)
          if (
            anchorEl &&
            LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) !== '1'
          )
            closePopover()
        }}
        dayMaxEvents
        eventDragMinDistance={5}
        eventDragStart={(e) => {
          console.log('drag start', e)

          closePopover()
          LocalStorage.set(LocalStorageKey.SHOULD_KEEP_POPUP, '1')
          LocalStorage.set(LocalStorageKey.DRAGGING, '1')
        }}
        eventDragStop={(dragStop) => {
          console.log('drag stop', dragStop)

          LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
          setTimeout(() => {
            LocalStorage.remove(LocalStorageKey.DRAGGING)
          }, 51)

          setTimeout(() => {
            const pendingEventData: EventDoc =
              dragStop.event.extendedProps.eventModel

            if (
              LocalStorage.get(LocalStorageKey.PENDING_EVENT_DATA) !== null ||
              isTrulyEmpty(pendingEventData._id)
            ) {
              pointTo(
                pendingEventData
                  ? document.getElementById(
                      eventIdForContainer(
                        pendingEventData,
                        Number(pendingEventData.StartDate) * 1000
                      ) ?? ''
                    )
                  : dragStop.el,
                'dragged'
              )
            }
          }, 250)
        }}
        eventResizeStart={() => {
          closePopover()
          LocalStorage.set(LocalStorageKey.SHOULD_KEEP_POPUP, '1')
          LocalStorage.set(LocalStorageKey.DRAGGING, '1')
        }}
        eventResizeStop={(resizeStop) => {
          LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
          setTimeout(() => {
            LocalStorage.remove(LocalStorageKey.DRAGGING)
          }, 51)
        }}
        direction={i18n.dir()}
        nowIndicator
        datesSet={props.onDatesSet}
        slotDuration={{ hours: 1 }}
        slotLabelInterval={{ minutes: 30 }}
        eventOrder={eventOrder(calendar.view)}
        moreLinkText={'more'}
        eventBackgroundColor={'transparent'}
        eventBorderColor={'transparent'}
        dayHeaderClassNames={dayHeaderClassNames}
        dayHeaderContent={(e) => {
          return (
            <DayHeaderContent
              groupId={props.group?._id}
              userSettings={props.userSettings}
              dayNameFormat={props.dayNameFormat}
              handleAddEvent={props.handleAddEvent}
              {...e}
            />
          )
        }}
        dayCellContent={DayCellContent}
        eventContent={(e) => {
          const event = e.event.extendedProps?.eventModel as EventDoc
          const { instanceStart, instanceEnd } = getEventInstanceTimes(
            e.event.startStr,
            e.event.endStr,
            e.event.allDay,
            event
          )
          return (
            <div
              onContextMenu={(mouseEvent) => {
                if (event._id?.length === 0 || isGuest()) return
                handleContextMenu(mouseEvent, event, instanceStart, instanceEnd)
                setEventForMenu(event)
              }}
              id={`${e.event.id}_${dayjs(e.event.start ?? Date()).format(
                'YYYY-MM-DD'
              )}`}
              onClick={() => {
                handleCloseContextMenu()
                setIsContextMenuOpen(false)
              }}
              ref={event && event._id?.length === 0 ? targetDivRef : undefined}
              style={{ height: '100%', width: '100%' }}
            >
              <EventContent
                ignoreDim={
                  (props.ignoreDim && !props.embedMode) ||
                  !event ||
                  (isTrulyEmpty(event._rev) && isTrulyEmpty(event.Text))
                }
                closeAll={false}
                embedMode={props.embedMode}
                {...e}
              />
            </div>
          )
        }}
        allDayContent={AllDayContent}
        slotLabelContent={SlotLabelContent}
        events={props.events}
        ref={props.calRef}
      />
    </>
  )
}

function eventOrder(view: CalendarRange) {
  return (a: any, b: any) => {
    const groupcalA = a.extendedProps?.eventModel as EventDoc
    const groupcalB = b.extendedProps?.eventModel as EventDoc
    const startA = a.start
    const startB = b.start
    const typeA = groupcalA?.Type ?? DocType.EVENT
    const typeB = groupcalB?.Type ?? DocType.EVENT

    const allDayA = groupcalA.AllDay === '1'
    const allDayB = groupcalB.AllDay === '1'

    const selectedGroup: string | null = LocalStorage.get(
      LocalStorageKey.SELECTED_GROUP
    )

    // Check if events are from the selected group
    const groupASelected = selectedGroup && groupcalA.GroupID === selectedGroup
    const groupBSelected = selectedGroup && groupcalB.GroupID === selectedGroup

    // non task types should be on top
    if (typeA !== DocType.TASK && typeB === DocType.TASK) {
      return -1
    } else if (typeA === DocType.TASK && typeB !== DocType.TASK) {
      return 1
    }

    if (isTrulyEmpty(groupcalA._id)) {
      return -1
    }

    if (groupASelected && !groupBSelected) {
      return -1
    } else if (!groupASelected && groupBSelected) {
      return 1
    }

    // Prioritize all-day events
    if (allDayA && !allDayB) {
      return -1
    } else if (!allDayA && allDayB) {
      return 1
    }

    // Sort by start time in descending order
    if (startA > startB) {
      return 1
    } else if (startA < startB) {
      return -1
    }

    return 0
  }
}

export async function addEventToDate(
  source: string,
  groupId: string | undefined,
  startTime: number,
  endTime: number,
  allDay: boolean,
  userSettings?: UserSettingsDoc
) {
  if (LocalStorage.get(LocalStorageKey.VISIBLE_EVENT) !== null) return
  const veryFirstGroup = await provideFirstGroup()
  let group: Model<GroupDoc> | GroupDoc | undefined = await localGroupById(
    groupId ?? ''
  )

  Analytics.getInstance().sendEvent(Events.EVENT_START_ADD_EVENT, {
    [EventProperties.LOCATION_ADD_EVENT]: source
  })

  let groupIdForEvent: string | undefined =
    group?._id ?? defaultGroupId(userSettings) ?? veryFirstGroup?._id

  if (groupIdForEvent === '' || !groupIdForEvent) {
    groupIdForEvent = defaultGroupId(userSettings) ?? veryFirstGroup?._id
  }

  Logger.orange('Adding event to group', group, groupIdForEvent, groupId)

  if (!group || (is24meApp() && !groupId)) {
    group = await localGroupById(groupIdForEvent ?? '')
    if (group && group.SyncProblem === '1') {
      group = undefined
    }
  }

  let thirdPartyId: string | undefined = groupToThirdPartyCalendarId(group)

  if (!userSettings) {
    return await isUserHaveGroupToAddEvents().then((groupId) => {
      return addTempEventToDate(
        startTime,
        endTime,
        groupId,
        allDay,
        is24meApp()
          ? groupId || group
            ? DocType.EVENT
            : DocType.TASK
          : DocType.EVENT,
        undefined,
        thirdPartyId,
        undefined,
        isConvertedGroup(group) ? TaskType.personalEvent : TaskType.meet
      )
    })
  }

  return await addTempEventToDate(
    startTime,
    endTime,
    groupIdForEvent,
    allDay,
    is24meApp()
      ? groupId || group
        ? DocType.EVENT
        : DocType.TASK
      : DocType.EVENT,
    undefined,
    thirdPartyId,
    undefined,
    isConvertedGroup(group) ? TaskType.personalEvent : TaskType.meet
  )
}

interface AddEventButtonProps extends CalendarViewProps {
  showUserRemoved: () => void
  userRemoved: boolean
  showUserBlockedFromAdding: () => void
  onShowOutOfTier: (b: boolean) => void
  groupOutOfTier: boolean
  handleAddEvent: (startEnd: StartEndEvent) => void
}

function AddEventButton(props: AddEventButtonProps) {
  return (
    <>
      <Styled.AddEventButton
        id="add-event-button"
        onClick={() => {
          const startEnd = generateStartEndBasedOnTimeWithShift(
            Number(LocalStorage.get(LocalStorageKey.VISIBLE_DATE)) / 1000
          )

          props.handleAddEvent(startEnd)
        }}
      >
        <AddIcon />
        <span>{t('event')}</span>
      </Styled.AddEventButton>
    </>
  )
}

export function ChatbaseButton() {
  if (is24meApp()) return <></>

  const chatbase = useChatbase()

  useEffect(() => {
    Logger.blue('Chatbase: isChatOpen changed', chatbase.isChatOpen)
  }, [chatbase.isChatOpen])

  return (
    <Tooltip enterDelay={600} title={t('supportChat')} placement="top">
      <Box
        onClick={() => {
          if (chatbase.isChatOpen) {
            chatbase.closeChat()
          } else {
            chatbase.openChat()
          }
        }}
        sx={{
          zIndex: 1001,
          fontSize: '20px',
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'background-color 0.2s ease',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
          }
        }}
      >
        {chatbase.isChatOpen ? (
          <Box
            component="span"
            sx={{
              color: 'white',
              fontSize: 'inherit',
              fontWeight: 'bold',
              lineHeight: 1
            }}
          >
            ✕
          </Box>
        ) : (
          <Box
            component="span"
            sx={{
              color: 'white',
              fontSize: 'inherit',
              fontWeight: 'bold',
              lineHeight: 1
            }}
          >
            ?
          </Box>
        )}
      </Box>
    </Tooltip>
  )
}

export default compose(
  withObservables([], () => ({
    account: ObserveService.Account()
  })),
  withObservables([], () => ({
    userSettings: ObserveService.UserSettings()
  })),
  withObservables([], (props: CalendarViewProps) => ({
    firstGroup: ObserveService.FirstGroup(props.userSettings)
  })),
  withObservables(['groupID'], (props: CalendarViewProps) => ({
    group: ObserveService.GroupByServerIDRestricted(props.groupID)
  })),
  withObservables([], (props: CalendarViewProps) => ({
    groups: ObserveService.Groups()
  })),
  withObservables(
    ['groupID', 'userSettings', 'visibleFrom'],
    (props: CalendarViewProps) => ({
      events: ObserveService.Events(undefined)
    })
  )
  // @ts-ignore
)(CalendarView as unknown as ComponentType<CalendarViewProps>) as any

interface MoreLinkProps {
  num: Number
}

const MoreLink = (props: MoreLinkProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'}>
      {t('moreAmount', { more: props.num })}
    </Box>
  )
}

export function groupToThirdPartyCalendarId(group?: GroupDoc) {
  let thirdPartyId: string | undefined = undefined
  if (!group) return undefined

  if (isConvertedGroup(group)) {
    const provider = groupToProvider(group)

    if (provider === ProviderType.GOOGLE) {
      thirdPartyId = CurrentConvertedCalendars.find(
        (calendar) =>
          calendar.prefix === prefixGoogleEventsGroup &&
          calendar.primaryCalendarEmail ===
            removePrefix(group.CalendarEmail ?? '')
      )?.primaryCalendarEmail
    } else if (provider === ProviderType.OUTLOOK) {
      thirdPartyId = CurrentConvertedCalendars.find(
        (calendar) => calendar.prefix === outlookPrefix && calendar.primary
      )?.id
    } else if (provider === ProviderType.APPLE) {
      thirdPartyId = CurrentConvertedCalendars.find(
        (calendar) => calendar.prefix === icloudPrefix && calendar.primary
      )?.id
    }
  }

  return thirdPartyId
}
